import React, { useState, useMemo } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  TextField,
  IconButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { categories, emojiForCategory } from 'src/utils/catmap';

const CategoryDialog = ({ open, onClose, selectedCategory, setSelectedCategory }) => {
  const [expanded, setExpanded] = useState(null);

  const primary_and_detailed_categories = useMemo(() => {
    const plaid_categories = {};
    const display_categories = {};

    categories.forEach(({ primaryKey, key, primary, detailed }) => {
      if (!display_categories[primary]) display_categories[primary] = [];
      if (!display_categories[primary].includes(detailed))
        display_categories[primary] = [...display_categories[primary], detailed];

      if (!plaid_categories[primaryKey]) {
        plaid_categories[primaryKey] = { name: primary, children: { [key]: detailed } };
      } else {
        plaid_categories[primaryKey].children[key] = detailed;
      }
    });

    return display_categories;
  }, [categories]);

  const handleToggle = (id) => {
    setExpanded((prev) => (prev === id ? null : id));
  };

  const handleSelectCategory = (category) => {
    setSelectedCategory(category);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth sx={{ zIndex: 10001 }}>
      <DialogTitle>Select a Category</DialogTitle>

      <DialogContent>
        <List component="div" disablePadding>
          {Object.entries(primary_and_detailed_categories).map(([parent, children]) => (
            <div key={parent}>
              <ListItemButton
                button
                onClick={() => handleSelectCategory({ id: parent, name: parent })}
              >
                <ListItemText primary={`${emojiForCategory(parent)} ${parent}`} />
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleToggle(parent);
                  }}
                >
                  {expanded === parent ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </ListItemButton>
              <Collapse in={expanded === parent} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {children.map((name) => (
                    <ListItemButton
                      key={name}
                      button
                      onClick={() => handleSelectCategory({ id: name, name })}
                      sx={{ pl: 4 }}
                    >
                      <ListItemText primary={name} />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </div>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

const GoalCategorySelector = ({ value: selectedCategory, onChange: setSelectedCategory }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <TextField
        label="Category"
        value={selectedCategory ? selectedCategory.name : ''}
        onClick={handleOpen}
        fullWidth
        readOnly
        size="small"
      />
      <CategoryDialog
        open={open}
        onClose={handleClose}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
      />
    </div>
  );
};

export default GoalCategorySelector;
